import React, { useState, useEffect, useRef } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  getRecipeDetailsByUUID,
  getRecipeList,
  logRecipeHistory,
} from "../../../services/index";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { getFormattedNumber, searchForMatch } from "../../utils/textUtils";
import { confirmAlert } from "react-confirm-alert";
import { LocalPrintshopOutlined } from "@mui/icons-material";
import { handleRecipePrintLogHistory } from "../../../services/Production/RecipeServices";

const ViewRecipe = (props) => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [logData, setLogData] = useState({});
  let recordId = useParams();
  const [data, setData] = useState(null);
  const [data2, setData2] = useState(null);
  const [recipe, setRecipe] = useState(null);
  const [recipeDetails, setRecipeDetails] = useState(null);
  const currentDate = new Date();

  const handleRowClick = (id) => {
    getRecipeDetails(id);
  };
  useEffect(() => {
    logRecipeHistory(id).then((res) => {
      if (res.errorCode === 0) {
        const d = res.responsePacket;
        setLogData(d);
      } else {
        toast(res.message);
      }
    });
  }, [id]);

  const getRecipeDetails = (id) => {
    getRecipeDetailsByUUID(id).then((res) => {
      if (res.errorCode === 0) {
        setRecipe(res.responsePacket);
        setRecipeDetails(res.responsePacket.ingredientsBeanList);
        let sub = 0;
        let quantity = 0;
        res.responsePacket.ingredientsBeanList &&
          res.responsePacket.ingredientsBeanList.map((item, i) => {
            sub +=
              (item.quantity / item.itemWeightValue) * Number(item.itemRate);
            quantity += item.quantity;
            // setQuantity(quantity);
          });
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleEditRecipe = (id) => {
    navigate("/recipe/" + id + "/edit");
  };

  useEffect(() => {
    getRecipeDetails(recordId.id);

    var request = {
      page: 0,
      search: "",
      size: -1,
    };
    getRecipeList(request).then((res) => {
      if (res.errorCode === 0) {
        setData(res.responsePacket.data);
        setData2(res.responsePacket.data);
      } else {
        toast.error(res.message);
      }
    });
  }, []);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      handleRecipePrintLogHistory(id).then((e) => {
        if (e.errorCode === 0) {
          toast.success("Recipe printed successfully");
        }
      })
    },
  });

  const handleSearch = (e) => {
    const result = data2.filter((a) => {
      return searchForMatch(a.itemTitle, e.target.value);
    });
    setData(result);
  };


  const totalAmmount = recipeDetails?.reduce((acc, item) => acc + item.amount, 0) || 0;

  return (
    <>
      <div
        className="column list-column d-print-none "
        style={{ width: "300px" }}
      >
        <div className="fill list-header topgrad d-print-none">
          <div className="list-filter pt-3 d-flex align-items-center">
            <Link to="/recipe/new" className="newListBtn">
              <AddIcon />
              New
            </Link>
            <div className="input-group paginationSearchInput listSearch">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  <SearchRoundedIcon />
                </span>
              </div>
              <input
                autoComplete="off"
                className="form-control"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="scroll-y fill body scrollbox list-body ">
          <div className="table-responsive overflow-initial ">
            <table
              id="ember456"
              className="table zi-table table-hover ember-view header-fixed"
            >
              <tbody>
                {data &&
                  data.map((data, i) => (
                    <tr
                      key={i}
                      className={`listTr ${id === data.recordId ? "activeRecord" : ""
                        }`}
                      onClick={() => handleRowClick(data.recordId)}
                    >
                      <td>
                        <Link
                          to={`/recipe/${data.recordId}`}
                          className={`${id === data.recordId ? "text-primary" : "text-grey"
                            }`}
                        >
                          <span className="titleTr">{data?.itemTitle}</span>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div id="ember493" className="ember-view">
            <div className="pagination clearfix d-print-none"> </div>
          </div>
        </div>
      </div>
      <div className="column content-column" style={{ left: "301px" }}>
        <div className="header no-border d-flex align-items-center p-4">
          <h6 className="listTopHeading">{recipe?.itemTitle}</h6>
          <a
            className="over-flow header-title text-uppercase"
            style={{ fontSize: "x-large" }}
          >
            &nbsp;
          </a>
          <div>
            <div className="btn-toolbar  d-flex justify-content-end align-items-center">
              <Link to={"/recipe/" + recipe?.recordId + "/edit"} state={{ newEdit: "true" }}>
                <button id='ember7700' className="tooltip-container ember-view btn btn-primary float-right" type='button'>
                  <ContentCopyIcon />
                </button>
              </Link>

              <button className="tooltip-container ember-view btn btn-primary float-right" onClick={() => {
                confirmAlert({
                  title: (
                    <span className="d-flex align-items-center justify-content-center" style={{ fontSize: "16px", fontWeight: "700" }}>
                      Print Recipe
                    </span>
                  ),
                  // message: <p className="text-center">Are you sure you want to logout?</p>,
                  buttons: [
                    {
                      label: "Yes",
                      onClick: () => {
                        handlePrint();
                      },
                      className: "logoutBtn",
                    },
                    {
                      label: "Cancel",
                      className: "logoutBtn",
                    },
                  ],
                })
              }} style={{ top: "10px", right: "0px" }}>
                <LocalPrintshopOutlined />
              </button>
              <button
                id="ember499"
                className="tooltip-container ember-view btn btn-primary"
                type="button"
                onClick={() => handleEditRecipe(recipe.recordId)}
              >
                <EditIcon />
              </button>
            </div>
          </div>
        </div>
        <Tabs className="upperTabs">
          <TabList>
            <Tab>Primary Details</Tab>
            <Tab>Log History</Tab>
          </TabList>
          <TabPanel>
            <div
              className="ember-view scroll-y noscroll-x fill body scrollbox py-3"
              id="pdf"
              ref={componentRef}
            >
              <span className="page-header-title">{recipe?.title}</span>
              <div className=" w-100 my-3">
                <p className="m-0 font-xlarge text-uppercase font-xs text-open">
                  {recipe?.itemTitle}
                </p>

              </div>
              {/* <div className="card p-3"> */}
              <div className="customTable" >
                {recipeDetails ? (
                  <table className="customTable w-100 borderedTable" >
                    <thead>
                      <tr>
                        <th className="pl-3">Step</th>
                        <th className="pl-3">Ingredients</th>
                        <th className="pl-3">Quantity</th>
                        <th className="pl-3">Unit</th>
                        <th className="pl-3">Rate </th>
                        <th className="pl-3">Instructions</th>
                        <th className="pl-3">Amount </th>
                      </tr>
                    </thead>
                    <tbody>
                      {recipeDetails &&
                        recipeDetails.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>{item?.stepOrder}</td>
                              <td>{item?.itemTitle}</td>
                              <td className="text-right">
                                {getFormattedNumber(item?.quantity, 4)}
                              </td>
                              <td> {item?.quantityUnitTitle}</td>
                              <td className="text-right">
                                {getFormattedNumber(item?.itemRate)}
                              </td>
                              <td>{item?.instruction}</td>
                              <td className="text-right">
                                {getFormattedNumber(item?.amount)}
                              </td>
                            </tr>
                          );
                        })}
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>Total:</td>
                        <td className="font-large text-uppercase font-xs text-open text-right">
                          ₹ {getFormattedNumber(totalAmmount)}
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          {recipe.isProduction
                            ? "for Production"
                            : "for Restaurant"}
                        </td>
                        <td></td>
                        <td>Batch Size:</td>

                        <td className="font-large text-uppercase font-xs ">
                          {getFormattedNumber(recipe?.quantity)}&nbsp;
                          {recipe?.quantityUnitTitle}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <></>
                )}
              </div>
              {/* </div> */}

              {/* pre code  <div id="ember522" >
                <div id="ember523" style={{ width: "100%" }}>
                  <table className="d-flex justify-content-center">
                    <tbody>
                      <tr>
                        <td className="font-xlarge text-uppercase font-xs text-open">
                          {recipe?.itemTitle}
                        </td>
                        <td className="font-xlarge text-uppercase font-xs text-open">
                          <span className="page-header-title pl-4">
                            {currentDate.getDate() +
                              "-" +
                              ((currentDate.getMonth() + 1 < 10 ? "0" : "") +
                                (currentDate.getMonth() + 1)) +
                              "-" +
                              currentDate.getFullYear()}
                            <span className="page-header-title pl-4">
                              {currentDate.getUTCHours() +
                                ":" +
                                currentDate.getUTCMinutes() +
                                ":" +
                                currentDate.getUTCSeconds()}
                            </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  {recipeDetails ? (
                    <table className="customTable w-100">
                      <thead>
                        <tr>
                          <th className="pl-4">Step</th>
                          <th className="pl-4">Ingredients</th>
                          <th className="pl-4 text-right">Quantity</th>
                          <th className="pl-4">Unit</th>
                          <th className="pl-4 text-right">Rate </th>
                          <th className="pl-4">Instructions</th>
                          <th className="pl-4 text-right">Amount </th>
                        </tr>
                      </thead>
                      <tbody className="ember-view scroll-y noscroll-x scrollbox">
                        {recipeDetails &&
                          recipeDetails.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{item?.stepOrder}</td>
                                <td>{item?.itemTitle}</td>
                                <td className="text-right">
                                  {getFormattedNumber(item?.quantity, 4)}
                                </td>
                                <td> {item?.quantityUnitTitle}</td>
                                <td className="text-right">
                                  {getFormattedNumber(item?.itemRate)}
                                </td>
                                <td>{item?.instruction}</td>
                                <td className="text-right">
                                  {getFormattedNumber(item?.amount)}
                                </td>
                              </tr>
                            );
                          })}
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>Total:</td>
                          <td className="font-large text-uppercase font-xs text-open text-right">
                            ₹ {getFormattedNumber(recipe?.totalAmount)}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            {recipe.isProduction
                              ? "for Production"
                              : "for Restaurant"}
                          </td>
                          <td></td>
                          <td>Batch Size:</td>

                          <td className="font-large text-uppercase font-xs ">
                            {getFormattedNumber(recipe?.quantity)}&nbsp;
                            {recipe?.quantityUnitTitle}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    <></>
                  )}
                </div>
              </div> */}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
              <table>
                {logData.length === 0 ? (
                  "No Changes Found"
                ) : (
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Changes</th>
                    </tr>
                  </thead>
                )}
                {logData.length >= 1 && (
                  <tbody>
                    {logData?.map((history, i) => (
                      <tr key={i}>
                        <td style={{ verticalAlign: "top" }}>
                          {history?.transactionDate?.substring(0, 10)}
                          :&nbsp;&nbsp;
                        </td>

                        <td>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: history?.message
                                .replaceAll("\n", "<br />")
                                .replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;"),
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </TabPanel>
        </Tabs>
      </div>
      <Toaster />
    </>
  );
};

export default ViewRecipe;
